import ImageCompare from 'image-compare-viewer';

const element = document.getElementById('image-compare');
const elementMobile = document.getElementById('image-compare-mobile');

if (window.innerWidth >= 1024) {
	window.scrollTo(0, 0);
}

window.scrollTo = () => {}; // Hack to prevent scroll to top after image compare handle move by image-compare-viewer

new ImageCompare(element).mount();
new ImageCompare(elementMobile).mount();